const floatMenu = () => {
	if (!$('body').hasClass('page-template-page-float-menu')) return null

	const sidebar = $('.js-sidebar')
	const summary = sidebar.find('.js-summary')
	const content = $('.js-content')
	const titles = content.find('h3')
	const navbarHeight = 110
	const offset = 250 - navbarHeight
	const top = sidebar.offset().top
	const controller = new ScrollMagic.Controller()
	const hasAdminBar = $('body').find('#wpadminbar').length

	// create anchors summary
	titles.each(function() {
		const title = $.trim($(this).text()).replace(/:$/g, '')
		const id = slugify(title)
		$(this).attr('id', id)
		summary.append(`<li><a href="#${id}">${title}</a></li>`)
	})

	if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
	} else {
		// Scroll to element on menu item click
		summary.find('li a').click(function(event) {
			const scrollTop = $(this.hash).offset().top - offset
			$('html, body').animate({ scrollTop }, 1000)
		})
	}

	// On scroll using scrollMagic
	let i1 = 0
	let i2 = 1
	const scene = new ScrollMagic.Scene().addTo(controller).on('update', () => {
		const direction = controller.info('scrollDirection')
		const winHeight = $(window).height()
		const winScrollTop = $(window).scrollTop()
		const docHeight = $(document).height()
		const fullDocHeight = winScrollTop + winHeight
		const isTop = top >= winScrollTop
		const isBottom = docHeight - fullDocHeight < 50
		const contentBottom = content.offset().top + content.outerHeight(true)
		const sidebarBottom = sidebar.offset().top + sidebar.outerHeight(true)
		const isBigger = sidebarBottom > contentBottom

		if ($(window).width() > 1000) {
			updateActiveMenuItem(isBottom)

			if (!isTop) {
				// Stickly position
				sidebar.addClass('fixed').removeClass('static')

				if (hasAdminBar) {
					sidebar.css('top', '52px')
				}
				/*
				// Follow navbar moving
				if (i1 === 0 && direction === 'REVERSE') {
					TweenLite.to(sidebar, 0.5, { y: navbarHeight })
					i1++
					i2 = 0
				}
				if (i2 === 0 && direction === 'FORWARD') {
					TweenLite.to(sidebar, 0.25, { y: 0 })
					i2++
					i1 = 0
				}
*/
			} else {
				// Reset
				TweenLite.to(sidebar, 0.25, { y: 0 })
				sidebar.removeClass('fixed').addClass('static')
			}
			/*
			if (isBigger) {
				sidebar.addClass('lock')
			}
			*/
		}
	})

	// update summary active link on scroll OR set last
	function updateActiveMenuItem(setLast = false) {
		if (setLast) {
			titles.removeClass('current')
			titles.last().addClass('current')
			summary.find('a').removeClass('active')
			summary
				.find(`a`)
				.last()
				.addClass('active')
		} else {
			titles.each(function() {
				const position = $(this).position().top + offset - $(window).scrollTop()
				if (position <= 0) {
					titles.removeClass('current')
					$(this).addClass('current')
					summary.find('a').removeClass('active')
					summary.find(`a[href="#${$(this).attr('id')}"]`).addClass('active')
				}
			})
		}
	}

	function slugify(str) {
		return $.trim(str)
			.replace(/[^a-z0-9-]/gi, '-')
			.replace(/-+/g, '-')
			.replace(/^-|-$/g, '')
			.toLowerCase()
	}
}

export { floatMenu }
